// src/app/auth.interceptor.ts
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  tag_key: String = "@Resource.Planner_2020";

  constructor() { }
  
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    var decryptedKey = "";
    var originalKey = "";
    if (
      sessionStorage.getItem("access_key") != null &&
      sessionStorage.getItem("access_key") != undefined
    ) {
      const decryptWithAES = (ciphertext: any, tag_key: any) => {
        const passphrase = tag_key;
        const bytes = CryptoJS.AES.decrypt(ciphertext, passphrase);
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        return originalText;
      };
      decryptedKey = decryptWithAES(
        sessionStorage.getItem("access_key"),
        this.tag_key
      );
      originalKey = decryptedKey.toString();
    }
    const modified = req.clone({
      headers: req.headers.set("Authorization", "Bearer " + originalKey),
    });
    return next.handle(modified);
  }
}